import { useDisclosure as useBaseDisclosure } from "@chakra-ui/react";

export default useBaseDisclosure;
